import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M50.5982 15.9247C43.144 1.31704 29.0088 1.82451 28.0969 1.88422C27.1849 1.94392 12.6731 2.08325 5.59556 15.9247C0.758268 25.3878 0.153624 42.0951 2.20551 54.9514C3.11745 60.693 8.33141 87.8684 28.0969 87.8684C47.8624 87.8684 53.0763 60.6731 53.9982 54.9116C56.0303 42.0652 55.4256 25.3878 50.5982 15.9247Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
